import Routes from 'Routes';
import { gspCollect } from '@csair/emp-helpers';
import { saveOldLocation } from '../../modules/actions';

export default store => ({
  path: Routes.ticket.child.electronicInvoice.key,
  onEnter(nextState, replace, callback) {
    gspCollect(
      [
        '2021-EMP退改-预约电子发票页面',
        '预约电子发票页面',
        '013-000-71001-103',
      ],
      { 6: '国内' },
      process.env.NODE_ENV === 'production'
    );
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const electronicInvoice = require('./components/electronicInvoice')
          .default;
        cb(null, electronicInvoice);
      },
      'electronicInvoice'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/electronicInvoice/index.js